import { useTranslation } from 'react-i18next';
import type { TimelineLayerId } from 'features/mapping/mapping.constants';
import { useTimelineLayerList } from 'features/mapping/hooks/useTimelineLayerList';
import { CommandPaletteAction } from 'components/CommandPaletteDialog/commandPaletteAction.types';
import { useKeyboardShortcuts } from 'hooks/useKeyboardShortcuts/useKeyboardShortcuts';
import { useMapMode } from 'hooks/useMapMode';

export const useTimelineCommandPaletteActions = (
  enabled: boolean,
  onToggle: (layerId: TimelineLayerId) => void,
): void => {
  const { t } = useTranslation();
  const { mapMode } = useMapMode();
  const layers = useTimelineLayerList();

  const actions: CommandPaletteAction[] = layers.map((layer) => ({
    category: 'mapLayers',
    description: t('keyboardShortcuts.timelineLayer.toggle', {
      layer: t(layer.titleKey),
      interpolation: { escapeValue: false },
    }),
    subtitle: t(layer.shortSubtitleKey),
    keys: layer.keyboardShortcut && `l ${layer.keyboardShortcut}`,
    isActive: mapMode === layer.id,
    handler: () => onToggle(layer.id),
  }));

  useKeyboardShortcuts(enabled ? actions : [], [
    enabled,
    layers,
    mapMode,
    onToggle,
  ]);
};
